module.exports = __webpack_public_path__ + "images/oos-black-6a23f672.svg";